import { useMediaQuery } from 'react-responsive';
import { theme } from '@fiverr-private/theme';

export interface UseMediaQueryOptions {
    reverse?: boolean;
    onChange?: Parameters<typeof useMediaQuery>[2];
}

export const usePentaMediaQuery = (
    breakpoint: keyof typeof theme.breakpoints,
    { reverse, onChange }: UseMediaQueryOptions = { reverse: false }
) => {
    const { breakpointsReverse, breakpoints } = theme;

    return useMediaQuery(
        {
            query: (reverse ? breakpointsReverse : breakpoints)[breakpoint],
        },
        undefined,
        onChange
    );
};

export const useIsSm = () => usePentaMediaQuery('sm');

export const useIsMd = () => usePentaMediaQuery('md');

export const useIsLg = () => usePentaMediaQuery('lg');

export const useIsXl = () => usePentaMediaQuery('xl');

export const useIsXxl = () => usePentaMediaQuery('xxl');
